import { CasinoGameSection } from '@/components/casino/lobby/CasinoGameSection'
import { CASINO_HOME_GAMES_COUNT } from '@/config/casino'
import { useGetCasinoGamesQuery } from '@/store/api/casinoApi'
import { LightningBoltIcon } from './icons'
import { RandomGameCard } from './RandomGameCard'

export function GamesWorthTrying() {
	const { data, isLoading, isError } = useGetCasinoGamesQuery({
		is_recommended: true,
		page: 1,
		per_page: CASINO_HOME_GAMES_COUNT,
	})

	const games = data?.data ?? []

	return (
		<CasinoGameSection
			title='Games worth trying'
			icon={<LightningBoltIcon className='h-7 w-7 text-warning' />}
			games={games}
			leading={<RandomGameCard games={games} />}
			isLoading={isLoading}
			isError={isError}
			emptyMessage='No recommended games are available right now.'
		/>
	)
}
